
import { Component, Vue, Ref } from 'vue-property-decorator';
import DefaultStep from '@/pages/Player/components/DefaultStep.vue';
import { Power4, TweenMax, TimelineMax, gsap, Elastic, Bounce } from 'gsap';

@Component
export default class StepSucceed extends DefaultStep {

}
